/* eslint-disable sonarjs/no-duplicate-string */
import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  title: {
    id: "b2b.zadost-detail.title",
    defaultMessage: "Request"
  },
  notFound: {
    id: "b2b.zadost-detail.not-found",
    defaultMessage: "Request"
  }
});

export default () => useMessages(MESSAGES);
